export const attendanceDevicePermissions = {
    List: 34000,
    Create: 34001,
    Update: 34002,
    ShowDetails: 34003,
    Delete: 34004,
}

export const attendanceMappingPermissions = {
    MappingList: 34100,
    MappingCreate: 34101,
    MappingDelete: 34102,
    PunchList: 34103,
}
